// eslint-disable-next-line @nx/enforce-module-boundaries
import { TRESPONSE_OTL_CAPACITIES_INFO } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellTree, TTableOptions } from '../../table.type';
import _ from 'lodash';

function _getCells(
  item: TRESPONSE_OTL_CAPACITIES_INFO['oplCapacities'][number],
  fieldInfo: TRESPONSE_OTL_CAPACITIES_INFO['fieldInfo'],
) {
  return _.map(fieldInfo, (val) => {
    switch (val.key) {
      case 'user_opl_id':
        return {
          type: 'TEXT_CELL',
          text: item.fields[val.key][0],
          hrefActionCB: 'ORDER_DETAILS_REDIRECT',
        };
      default:
        return {
          type: 'TEXT_CELL',
          text: item.fields[val.key][0],
        };
    }
  }) as TTableCellTree[];
}

function _getHeaderConfig(fieldInfo: TRESPONSE_OTL_CAPACITIES_INFO['fieldInfo'], res?: TRESPONSE_OTL_CAPACITIES_INFO) {
  const allocatedSahHeaderSubtxt: string = res ? `${res.allocatedCapacity} / ${res.installedCapacity}` : '';
  const capacityUtilizedHeaderSubtxt: string = res
    ? `${((res.allocatedCapacity / res.installedCapacity) * 100).toFixed(2)}% `
    : '';
  return fieldInfo.map((x) => {
    const defaultInfo: TTableOptions['headerConfig'][number] = {
      type: 'TEXT_CELL',
      text: x.display_name,
    };

    switch (x.key) {
      case 'user_opl_id':
        return {
          ...defaultInfo,
          widthInPx: 100,
        };
      case 'allocated_sah':
        return {
          ...defaultInfo,
          subtitle: {
            text: allocatedSahHeaderSubtxt,
            align: 'BLOCK',
            fontSizeInPx: 14,
          },
        };
      case 'capacity_utilized':
        return {
          ...defaultInfo,
          subtitle: {
            text: capacityUtilizedHeaderSubtxt,
            align: 'BLOCK',
            fontSizeInPx: 14,
          },
        };
      default:
        return defaultInfo;
    }
  }) as TTableOptions['headerConfig'];
}

export const OTL_ORDER_INFO_TABLE_MODEL = {
  createModel: (
    fieldInfo: TRESPONSE_OTL_CAPACITIES_INFO['fieldInfo'],
    oplCapacities: TRESPONSE_OTL_CAPACITIES_INFO['oplCapacities'],
    res?: TRESPONSE_OTL_CAPACITIES_INFO,
  ) => {
    return ModifiersZTableModel.createTableModel(
      oplCapacities,
      { headerConfig: _getHeaderConfig(fieldInfo, res) },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: _getCells(item, fieldInfo),
        };
      },
    );
  },
};
